import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { skills, SkillCategory } from "../../data/skills";
import { getSkillIcon } from "../../data/skillIcons";
import { fadeUpItem, staggerContainer } from "../../animations/variants";
import { usePrefersReducedMotion } from "../../hooks/usePrefersReducedMotion";
import "./Skills.css";

const CATEGORY_ORDER: { category: SkillCategory; labelKey: string }[] = [
  { category: "language", labelKey: "categoryLanguage" },
  { category: "framework", labelKey: "categoryFramework" },
  { category: "styling", labelKey: "categoryStyling" },
  { category: "tool", labelKey: "categoryTool" },
];

function Skills() {
  const { t } = useTranslation();
  const prefersReducedMotion = usePrefersReducedMotion();
  const container = prefersReducedMotion ? {} : staggerContainer(0.05);

  return (
    <section id="skills" className="skills">
      <div className="section-inner">
        <h2 className="section-title">{t("skills.sectionTitle")}</h2>
        <div className="skills-groups">
          {CATEGORY_ORDER.map(({ category, labelKey }) => {
            const groupSkills = skills.filter((skill) => skill.category === category);
            if (groupSkills.length === 0) return null;

            return (
              <div key={category} className="skills-group">
                <h3 className="skills-group-title">{t(`skills.${labelKey}`)}</h3>
                <motion.div
                  className="skills-grid"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  variants={container}
                >
                  {groupSkills.map((skill) => {
                    const Icon = getSkillIcon(skill);
                    return (
                      <motion.div
                        key={skill.id}
                        className="skill-tile"
                        variants={prefersReducedMotion ? {} : fadeUpItem}
                        title={t(`skills.${skill.id}.blurb`)}
                      >
                        {Icon && <Icon className="skill-icon" aria-hidden="true" />}
                        <span>{t(`skills.${skill.id}.name`)}</span>
                      </motion.div>
                    );
                  })}
                </motion.div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Skills;
